import { render, staticRenderFns } from "./ModalFeedbackAdded.vue?vue&type=template&id=049547c1&"
import script from "./ModalFeedbackAdded.vue?vue&type=script&lang=js&"
export * from "./ModalFeedbackAdded.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedbackAdded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports